// src/pages/auth/confirm.jsx
import { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

// Se utiliza VITE_STRAPI_URL para obtener la URL del backend.
// Es importante que esta variable se defina en el entorno de Vercel.
const API_URL = import.meta.env.VITE_STRAPI_URL || "http://localhost:1337";

function Confirm() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState("Verificando token...");
  const didFetchRef = useRef(false);

  useEffect(() => {
    if (didFetchRef.current) return; // Evita la petición doble en StrictMode
    didFetchRef.current = true;

    const token = searchParams.get("token");
    if (!token) {
      setMessage("No se encontró ningún token en la URL.");
      return;
    }

    console.log("Llamando a:", `${API_URL}/api/auth/email-confirmation?confirmation=${token}`);

    fetch(`${API_URL}/api/auth/email-confirmation?confirmation=${token}`)
      .then(async (res) => {
        if (res.status === 200 || res.status === 302) {
          setMessage("Correo verificado exitosamente. Redirigiendo...");
          navigate("/correo-confirmado");
        } else {
          const data = await res.json();
          if (res.status === 400 && data.error?.message === "Invalid token") {
            setMessage("Este enlace ya fue utilizado o es inválido.");
          } else {
            setMessage("Ocurrió un error durante la confirmación.");
          }
        }
      })
      .catch((err) => {
        console.error("Error de conexión:", err);
        setMessage("No se pudo conectar con el servidor.");
      });
  }, [searchParams, navigate]);

  return (
    <div style={{ textAlign: "center", marginTop: "2rem" }}>
      <h2>{message}</h2>
    </div>
  );
}

export default Confirm;